module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shelf/resources/resources.component.css
// module id = ./src/app/shelf/resources/resources.component.css
// module chunks = main